import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import lottie from 'vue-lottie';
import XLSX from 'xlsx'
import VueClipboard from 'vue-clipboard2'
import VCharts from 'v-charts'
Vue.use(VueClipboard)

Vue.prototype.XLSX = XLSX 
Vue.use(ElementUI);
Vue.use(VCharts)
Vue.component('lottie', lottie)
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

